export default __webpack_public_path__ + "static/media/installment_modification.fdb32c25.svg";